import { useMutation } from '@apollo/client'
import gql from 'graphql-tag'
import { NewProfileInput, ProfileMutationOutput } from 'epc-schema'

/**
 * This mutation will create the user's profile upon
 * form submission.
 */
const CREATE_PROFILE_MUTATION = gql`
  mutation CreateProfile($profileInput: NewProfileInput!) {
    response: createProfile(profileInput: $profileInput) {
      errors {
        message
        path
      }
      success
    }
  }
`

export const useCreateProfile = () =>
  useMutation<
    { response: ProfileMutationOutput },
    { profileInput: NewProfileInput }
  >(CREATE_PROFILE_MUTATION)
